import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders, HttpResponse } from "@angular/common/http";
import { PagedApiResponse } from "../../utils/types/shared/_paged-api-response.type";
import { SMS_ENDPOINTS } from "../../components/mediaManager/campanias/sms/sms-endpoints";

import { FilterType } from "../../utils/types/shared/_filter.type";
import { Observable } from "rxjs";
import { SmsMapper } from "../../utils/mappers/sms/sms.mapper";
import { Sms } from "../../utils/types/sms/sms.type";
import { BaseApiService } from "../shared/base.api.service";
import { KeyValue } from "../../utils/types/shared/keyvalue.type";
import { SharedCatalogMapper } from "../shared/sharedcatalog.service";
import { BaseMapper } from "../../utils/mappers/shared/base.mapper";

import { environment as env } from "../../../environments/environment";
import { SmsDTO } from "../../utils/types/sms/smsDTO.type";
import { AuthenticationService } from "../security/authentication.service";
import { SmsCsvDTO } from "../../utils/types/sms/smsCsvDTO.type";
import { UploadCsvResponse } from "../../utils/types/shared/uploadCsvResponse";
import { SmsInstantDTO } from "../../utils/types/sms/smsInstantDTO.type";
import { User } from "../../utils/types/security/user.type";
import * as moment from "moment";
import { map } from "rxjs/operators";
import { SharedMapper } from "../../utils/mappers/shared/_shared.mapper";

@Injectable()
export class SmsService {
    model = Sms;
    mapper: SmsMapper = new SmsMapper();
    apiEndPoint: any = SMS_ENDPOINTS;

    constructor(
        protected http: HttpClient,
        public sharedMapper: SharedMapper
    ) {}

    sharedmapper() {
        return this.sharedMapper;
    }

    getList(filter?: FilterType): Observable<PagedApiResponse<Sms>> {
        /*
        const id = AuthenticationService.getCurrentUserInformation().id;
       // console.log(id);
       // console.log(filter.pageSize);
       // console.log(filter.page);
*/
        console.log(filter);
        return this.http.post(this.apiEndPoint.list, filter).pipe(
            map((res) => {
                return this.mapper.mapPagedApiResponse(
                    res,
                    this.mapper.mapList,
                    this.model
                );
            })
        );
    }

    delete(id: number): Observable<boolean> {
        return this.http
            .delete(this.apiEndPoint.item.replace("{id}", id.toString()), {
                observe: "response",
            })
            .pipe(
                map((res) => {
                    if (res.status === 200) {
                        return true;
                    }
                    return false;
                })
            );
    }

    create(data: SmsInstantDTO): Observable<any> {
        return this.http.post(this.apiEndPoint.base, data).pipe(
            map((res) => {
                return res;
            })
        );
    }

    createProgramado(data: SmsDTO): Observable<any> {
        // const userData: User = BaseMapper.map(AuthenticationService.getCurrentUserInformation(), User ) ;
        // data.id_user = userData.id;
        // data.user = new User();

        // data.user.active = userData.active;
        // data.user.firstName = userData.firstName;
        // data.user.id = userData.id;
        // data.user.lastName = userData.lastName;
        // data.user.organizationId = userData.organizationId;
        // data.user.roles = userData.roles;
        // data.user.username = userData.username;

        data.execute_date = moment(data.execute_date).format("YYYY-MM-DD");
        data.execute_end_date = moment(data.execute_end_date).format(
            "YYYY-MM-DD HH:mm:ss"
        );

        return this.http.post(this.apiEndPoint.programado, data).pipe(
            map((res) => {
                return res;
            })
        );
    }

    getBaseList(id, filter) {
        return this.http
            .post(this.apiEndPoint.getBaseList.replace("{id}", id), filter)
            .pipe(
                map((res) => {
                    return res;
                })
            );
    }

    updateProgramado(data: SmsDTO): Observable<boolean> {
        //   const userData: User = BaseMapper.map(AuthenticationService.getCurrentUserInformation(), User ) ;
        //   data.id_user = userData.id;
        //   data.user = new User();

        //   data.user.active = userData.active;
        //   data.user.firstName = userData.firstName;
        //   data.user.id = userData.id;
        //   data.user.lastName = userData.lastName;
        //    data.user.organizationId = userData.organizationId;
        //   data.user.roles = userData.roles;
        //   data.user.username = userData.username;

        data.execute_date = moment(data.execute_date).format("YYYY-MM-DD");
        data.execute_end_date = moment(data.execute_end_date).format(
            "YYYY-MM-DD HH:mm:ss"
        );

        return this.http.put<boolean>(this.apiEndPoint.programado, data).pipe(
            map((res) => {
                return res;
            })
        );
    }

    get(id: Number): Observable<Sms> {
        return this.http
            .get(this.apiEndPoint.item.replace("{id}", id.toString()))
            .pipe(
                map((res) => {
                    return BaseMapper.map(res, this.model);
                })
            );
    }

    getIdNameOperatorList(companyId: Number): Observable<Array<KeyValue>> {
        const keyValueMapper = new SharedCatalogMapper();

        return this.http
            .get(this.apiEndPoint.idNames.replace("{id}", companyId.toString()))
            .pipe(
                map((res) => {
                    return keyValueMapper.mapList(res, KeyValue);
                })
            );
    }

    getIdNameList(filter?: FilterType): Observable<PagedApiResponse<KeyValue>> {
        const keyValueMapper = new SharedCatalogMapper();

        return this.http.post(this.apiEndPoint.idNames, filter).pipe(
            map((res) => {
                return this.sharedMapper.mapPagedApiResponse<KeyValue>(
                    res,
                    keyValueMapper.mapList,
                    this.model
                );
            })
        );
    }

    getItemsIdNameList(
        vendorId: Number,
        filter?: FilterType
    ): Observable<PagedApiResponse<KeyValue>> {
        const keyValueMapper = new SharedCatalogMapper();

        return this.http
            .post(
                this.apiEndPoint.itemIdNames.replace(
                    "{id}",
                    vendorId.toString()
                ),
                filter
            )
            .pipe(
                map((res) => {
                    return this.sharedMapper.mapPagedApiResponse<KeyValue>(
                        res,
                        keyValueMapper.mapList,
                        KeyValue
                    );
                })
            );
    }

    uploadCSV(data: SmsCsvDTO): Observable<UploadCsvResponse> {
        const formData = new FormData();

        formData.append("file", data.file, data.file.name);
        formData.append("delimeter", data.delimeter);
        formData.append("name", data.name);
        formData.append("IdShortCode", data.IdShortCode.toString());
        formData.append("serviceType", data.serviceType);
        formData.append("longUrl", data.longUrl);
        formData.append("validityPeriod", data.validityPeriod.toString());
        formData.append("obfuscated", data.obfuscated.toString());

        return this.http
            .post<UploadCsvResponse>(this.apiEndPoint.upload, formData)
            .pipe(
                map((res) => {
                    return res;
                })
            );
    }

    getReportingData(id, filter): Observable<any> {
        return this.http
            .post<any>(
                this.apiEndPoint.getReportingData.replace("{id}", id),
                filter
            )
            .pipe(map((response) => response));
    }

    activationToggle(id: number): Observable<boolean> {
        return this.http.put<boolean>(
            this.apiEndPoint.activation.replace("{id}", id.toString()),
            null
        );
    }
}
